const SOCIAL_COLORS = {
  facebook: '#1877F2',
  twitter: '#1DA1F2',
  instagram: '#E4405F',
  linkedin: '#0A66C2',
  youtube: '#FF0000',
  tiktok: '#000000',
  pinterest: '#E60023',
  github: '#333333'
}

const SOCIAL_LABELS = {
  facebook: 'f',
  twitter: '𝕏',
  instagram: 'ig',
  linkedin: 'in',
  youtube: '▶',
  tiktok: '♪',
  pinterest: 'P',
  github: '⌨'
}

export default function SocialBlock({ settings }) {
  const { padding, margin, backgroundColor, textAlign, iconSize, iconSpacing, iconStyle, iconRadius, networks } = settings

  const containerStyle = {
    padding: `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}`,
    margin: `${margin.top} ${margin.right} ${margin.bottom} ${margin.left}`,
    backgroundColor: backgroundColor || 'transparent',
    textAlign: textAlign || 'center'
  }

  const enabledNetworks = (networks || []).filter(n => n.enabled)
  const size = parseInt(iconSize) || 32

  return (
    <div style={containerStyle}>
      <div style={{ display: 'inline-flex', gap: `${iconSpacing || 8}px`, alignItems: 'center', flexWrap: 'wrap', justifyContent: textAlign || 'center' }}>
        {enabledNetworks.map((network, idx) => {
          const color = SOCIAL_COLORS[network.name] || '#333'
          const bgColor = iconStyle === 'colored' ? color : (iconStyle === 'dark' ? '#333333' : '#e5e7eb')
          const textColor = iconStyle === 'light' ? '#333333' : '#ffffff'

          return (
            <a
              key={idx}
              href={network.url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: `${size}px`,
                height: `${size}px`,
                backgroundColor: bgColor,
                borderRadius: iconRadius || '50%',
                textDecoration: 'none',
                color: textColor,
                fontSize: `${Math.round(size * 0.4)}px`,
                fontWeight: 'bold',
                fontFamily: 'Arial, sans-serif'
              }}
              title={network.name}
            >
              {SOCIAL_LABELS[network.name] || network.name.charAt(0).toUpperCase()}
            </a>
          )
        })}
        {enabledNetworks.length === 0 && (
          <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>Enable social networks in settings</span>
        )}
      </div>
    </div>
  )
}
